import React, { useEffect, useState } from "react";
import { scrollToSection } from "../lib/scrollToSection";
import { useSettings } from "../lib/settings";
import { leadFormCopy } from "../lib/leadForm";

export default function StickyCTA() {
  const [show, setShow] = useState(false);
  // "Vreau detalii" or "Vreau broșura", matching what the form will deliver.
  const { stickyCta } = leadFormCopy(useSettings().lead_form_mode);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 inset-x-0 z-30 transition-transform duration-300 md:hidden ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
      data-testid="sticky-cta"
    >
      <div className="m-3 rounded-2xl glass border border-[#E5E7EB] shadow-2xl flex items-stretch overflow-hidden">
        <button
          onClick={() => scrollToSection("lead-form")}
          className="flex-1 px-4 py-3 text-sm font-semibold text-[#373A45] hover:bg-[#E5E7EB]"
          data-testid="sticky-cta-brochure"
        >
          {stickyCta}
        </button>
        <button
          onClick={() => scrollToSection("pricing")}
          className="flex-1 px-4 py-3 text-sm font-semibold bg-[#965EA7] text-white hover:bg-[#7A4986]"
          data-testid="sticky-cta-enroll"
        >
          Înscrie-te
        </button>
      </div>
    </div>
  );
}
